/**
 * The layers of what opens over the page — a panel from the right, a drawer, a dialog — in the
 * order they open: the last one lies on top, whatever kind it is (a dictionary edited from a field
 * of a panel opens over that panel, not under it). Each takes the next layer when it opens and
 * gives it back when it closes; with all closed they start again from the bottom. What floats
 * from one of them (a dropdown) goes just above it (useFloating); what floats on the page itself
 * (45) stays under them all, toasts over them all.
 */
const BOTTOM = 50
let top = BOTTOM
let held = 0

export function takeLayer() {
  held += 1
  top += 2
  let given = false
  return {
    z: top,
    release() {
      if (given) return
      given = true
      held -= 1
      if (held === 0) top = BOTTOM
    },
  }
}
